import { AbstractControl, ValidatorFn } from '@angular/forms';

export function dateFormatValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    if (!control.value) {
      return null; // Si le champ est vide, laissons les autres validateurs (required) s'en occuper
    }

    const dateRegex = /^(\d{2})-(\d{2})-(\d{4})$/;
    const match = control.value.match(dateRegex);
    
    if (!match) {
      return { 'invalidDateFormat': { value: control.value } };
    }
    
    const day = parseInt(match[1], 10);
    const month = parseInt(match[2], 10);
    const year = parseInt(match[3], 10);
    
    // Vérifications de base
    if (month < 1 || month > 12) {
      return { 'invalidMonth': { value: control.value } };
    }
    
    if (day < 1 || day > 31) {
      return { 'invalidDay': { value: control.value } };
    }
    
    // Vérifications plus précises selon le mois
    const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    
    // Année bissextile
    if (month === 2 && isLeapYear(year)) {
      daysInMonth[1] = 29;
    }
    
    if (day > daysInMonth[month - 1]) {
      return { 'invalidDayForMonth': { value: control.value } };
    }
    
    // Vérifier que l'année est raisonnable (entre 1900 et 2100)
    if (year < 1900 || year > 2100) {
      return { 'invalidYear': { value: control.value } };
    }
    
    return null; // Validation réussie
  };
}

export function futureDateValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    if (!control.value) {
      return null;
    }

    const dateRegex = /^(\d{2})-(\d{2})-(\d{4})$/;
    const match = control.value.match(dateRegex);
    
    if (!match) {
      return null; // Laissons dateFormatValidator s'occuper du format
    }
    
    const day = parseInt(match[1], 10);
    const month = parseInt(match[2], 10);
    const year = parseInt(match[3], 10);
    
    const inputDate = new Date(year, month - 1, day);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Réinitialiser l'heure pour comparer seulement les dates
    
    if (inputDate < today) {
      return { 'pastDate': { value: control.value } };
    }
    
    return null;
  };
}

export function pastDateValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    if (!control.value) {
      return null;
    }

    const dateRegex = /^(\d{2})-(\d{2})-(\d{4})$/;
    const match = control.value.match(dateRegex);
    
    if (!match) {
      return null; // Laissons dateFormatValidator s'occuper du format
    }
    
    const day = parseInt(match[1], 10);
    const month = parseInt(match[2], 10);
    const year = parseInt(match[3], 10);
    
    const inputDate = new Date(year, month - 1, day);
    const today = new Date();
    
    if (inputDate > today) {
      return { 'futureDate': { value: control.value } };
    }
    
    return null;
  };
}

function isLeapYear(year: number): boolean {
  return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
}